module.exports = __webpack_public_path__ + "img/accountSettings.141144b.svg";